import { format, parseISO } from 'date-fns';
import { t } from 'i18next';
import { capitalizeFirstLetter } from '~/helpers/capitalizeFirstLetter';
import { FullProg_v4 } from '~/providers/types';
import { Exception, Schedule } from './types';

const daysMapping: { [key: string]: string } = {
  mon: 'Seg',
  tue: 'Ter',
  wed: 'Qua',
  thu: 'Qui',
  fri: 'Sex',
  sat: 'Sáb',
  sun: 'Dom',
};

const defaultDays = {
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false,
};

export function parseDamProgramming(prog: FullProg_v4, enabledEco?: boolean): {
  schedules: Schedule[],
  exceptions: Exception[],
} {
  const modoEco = enabledEco ? '1_CONTROL' : null;

  const groupedSchedules: { [key: string]: string[] } = {};
  for (const [day, { start, end, permission }] of Object.entries(prog.week)) {
    if (permission !== 'allow' && permission !== 'forbid') continue;

    const key = `${start}-${end}-${permission}`;
    if (!groupedSchedules[key]) {
      groupedSchedules[key] = [];
    }
    groupedSchedules[key].push(day);
  }

  const schedules: Schedule[] = Object.entries(groupedSchedules).map(([key, schedules]) => {
    const [start, end, permission] = key.split('-');

    const days = schedules.reduce(
      (acc, day) => ({ ...acc, [day]: true }),
      { ...defaultDays },
    );

    const scheduleTitle = `${t('programacao')} ${schedules
      .map((day) => capitalizeFirstLetter(daysMapping[day] ?? day))
      .join(', ')}`;

    return {
      title: scheduleTitle,
      beginTime: start,
      endTime: end,
      permission: permission as 'allow' | 'forbid',
      days,
      status: true,
    };
  });

  const exceptions: Exception[] = Object.entries(prog.exceptions ?? {}).map(([date, exception]) => {
    const dateString = format(parseISO(date), 'dd/MM/yyyy');
    return {
      beginTime: exception.start,
      endTime: exception.end,
      controlOperation: modoEco,
      date: dateString,
      permission: exception.permission,
      status: true,
      title: dateString,
    };
  });

  return {
    schedules,
    exceptions,
  };
}
